<template>
	<div class="wrapper">
		<div class="search">
			<input type="text" class="txt" placeholder="门店名称/门店地址" @input="specifiName($event)">
		</div>
		<div class="body">
			<scroller height="100%" :no-data-text="this.loadingTips" :on-refresh="refresh" :on-infinite="infinite" ref="scrollerBottom">
				<main class="scrollerContent">
					<!-- <div v-for="item in list" class="list">{{item}}</div> -->
					<div class="list" v-for="item in list" :key="item.id">
						<img src="https://yzg-img.oss-cn-hangzhou.aliyuncs.com/eticket/20210309/sjlh.png" alt="世纪联华">
						<div class="rt">
							<h1>{{item.storeName}}</h1>
							<p>{{item.storeAddress}}</p>
						</div>
					</div>
				</main>
			</scroller>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			let self = this;
			return {
				isBottom: false,
				loadingTips: '',
				page: 1,
				list: [],
				name: '',
				// 街道名称
				city: '',
				loaded: false,
			}
		},
		created() {
			this.initDataList()
		},
		methods: {
			initDataList() {
				this.getDataList('', 1);
			},
			specifiName(e) {
				this.name = e.target.value;
				this.getDataList(this.name, 1);
			},
			getDataList(name, pageNum, done) {
				const obj = {
					name: name,
					pageNum: pageNum,
					pageSize: 7
				};
				this.$http.POST('sjlhStore/listStore', obj).then(res => {
					if (res.code === 0) {
						if (typeof(done) == "function") {
							done();
						}
						if (res.data.list.length !== 0) {
							this.isBottom = false;
							if (pageNum == 1) {
								this.list = res.data.list;
							} else {
								this.list = this.list.concat(res.data.list);
							}

						} else {
							this.$refs.scrollerBottom.finishInfinite(false);
							this.list = [];
							this.isBottom = true;
						}
					}
				});
			},
			refresh(done) { //下拉刷新
				this.page = 1;
				this.list = [];
				if (this.city && this.city !== '') {
					this.name = this.city
				}
				this.getDataList(this.name, 1,done);
			},
			infinite(done) { //上拉加载
				if (this.isBottom) { //当没有更多数据的时候结束加载
					this.loadingTips = "无更多数据"
					setTimeout(() => {
						done && done(true);
					}, 1000);
				} else { //有更多数据时进行数据分页显示
					setTimeout(() => {
						this.page++;
						// this.getDataList(this.page);
						if (this.city && this.city !== '') {
							this.name = this.city
						}
						if (this.list.length % 7 == 0 && this.page > 1) {
							this.getDataList(this.name, this.page, done);
						} else {
							this.loadingTips = "无更多数据"
							setTimeout(() => {
								done && done(true);
							}, 1000);
						}
						this.$nextTick(() => {
							// this.$refs.scrollerBottom.reset()
						})
					}, 500)
				}
			},
		},

		mounted() {

		}
	}
</script>
<style lang="scss" scoped>
	.wrapper {
		height: 100%;
		position: relative;

		.search {
			padding: 8px 9px;
			background: #fff;

			.txt {
				height: 30px;
				line-height: 30px;
				width: 323px;
				background: url('../assets/search.png') 14px center #F3F3F3 no-repeat;
				background-size: 14px 14px;
				border: none;
				border-radius: 1px;
				color: #9C9C9D;
				font-size: 15px;
				padding-left: 34px;
			}
		}

		.body {
			margin-top: 10px;
			background: #fff;
			width: 100%;
			height: 88%; //有header的时候可能会出现滚动条，所以最好高度是除去header的高度
			top: 50px; //一般页面有header的时候需要留出header的高度
			bottom: 20px;
			position: absolute;

			main {
				height: 100%;

				.list {
					border-bottom: 1px solid #F3F3F3;
					display: flex;
					padding: 12px 15px;
					align-items: center;

					img {
						width: 65px;
						height: 65px;
					}

					.rt {
						flex: 1;
						padding-left: 15px;

						h1 {
							color: #333333;
							font-weight: bold;
							font-size: 16px;
						}

						p {
							color: #666666;
							font-size: 14px;
							padding-bottom: 16px;
						}

						.eval {
							display: flex;
							align-items: center;

							.star {
								// flex: 1;
								width: 75px;
								height: 15px;
								background: url('../assets/star1.png') repeat-x;
								background-size: 15px 15px;
								display: flex;

								span {
									width: 15px;
									background: url('../assets/star2.png') repeat-x;
									background-size: 15px 15px;
								}
							}

							.dist {
								flex: 1;
								display: flex;

								span {
									height: 21px;
									line-height: 21px;
									flex: 1;
									text-align: right;
									font-size: 15px;
									color: #666666;
									background: url('../assets/dist1.png') right center no-repeat;
									background-size: 12px 14px;
									padding-right: 17px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
